import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabButton", "tab"]

  showTab(event) {
    const button = event.currentTarget
    const tabName = button.dataset.tab

    // Update button states
    this.tabButtonTargets.forEach(btn => btn.classList.remove('active'))
    button.classList.add('active')

    // Update tab visibility
    this.tabTargets.forEach(tab => {
      tab.style.display = 'none'
      tab.classList.remove('active')
    })

    const targetTab = document.getElementById(`${tabName}-tab`)
    if (targetTab) {
      targetTab.style.display = 'block'
      targetTab.classList.add('active')
    }
  }
}

